import { LocationInterface } from '@/shared/interfaces/location.interface';
import { Participant } from '@/manager/convocation/participant.model';
import { Product } from '@/manager/product/models/product.model';
import { TimetablesInterface } from '@/shared/interfaces/timetables.interface';
import { LibraryInterface } from '@/shared/interfaces/library.interface';
import { DelegationInterface } from '@/shared/interfaces/delegation.interface';

export interface ConvocationInterface {
    id?: string;
    capacity?: number;
    confirmationDate?: string;
    delegation?: DelegationInterface;
    expander?: string;
    location?: LocationInterface;
    maxParticipants?: number;
    maxRepeatParticipants?: number;
    participantsToCall?: number;
    participants?: Participant[];
    place?: string;
    product: Product;
    timetables?: TimetablesInterface[];
    library?: LibraryInterface[];
    nextConvocation?: string;
    prevConvocation?: string;
    salesAmount?: number;
    amountItemsSold?: number;
    totalParticipantAbandonment?: number;
    totalParticipantSummoned?: number;
    totalParticipantConfirmed?: number;
    totalParticipantChecked?: number;
    totalParticipantNotConfirmed?: number;
    totalParticipantOut?: number;
    totalParticipantPostpone?: number;
    totalParticipantEnrolled?: number;
    trainer?: any;
    eventManager?: any;
    urlMap?: string;
    openDate?: boolean;
    openDelegation?: boolean;
    isPendingPostponeList?: boolean;
    sendMailType?:number;
    states?:any;
}

export class Convocation implements ConvocationInterface {
    public id?: string | undefined;
    public capacity?: number;
    public confirmationDate?: string;
    public delegation?: DelegationInterface;
    public expander?: string;
    public location?: LocationInterface;
    public maxParticipants?: number;
    public maxRepeatParticipants?: number;
    public participantsToCall?: number;
    public participants?: Participant[];
    public place?: string;
    public product: Product;
    public timetables?: TimetablesInterface[];
    public library?: LibraryInterface[];
    public nextConvocation?: string;
    public prevConvocation?: string;
    public salesAmount?: number;
    public amountItemsSold?: number;
    public totalParticipantAbandonment?: number;
    public totalParticipantSummoned?: number;
    public totalParticipantConfirmed?: number;
    public totalParticipantChecked?: number;
    public totalParticipantOut?: number;
    public totalParticipantNotConfirmed?: number;
    public totalParticipantPostpone?: number;
    public totalParticipantEnrolled?: number;
    public trainer?: any;
    public eventManager?: any;
    public urlMap?: string;
    public openDate?: boolean;
    public openDelegation?: boolean;
    public hideBudgetAceptation?: boolean;
    public isPendingPostponeList?: boolean;
    public sendMailType?:number;
    public postponable?:boolean;
    public states?: any;

    constructor() {
        this.product = new Product();
    }
}
